'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'chevron-down',
    /* eslint-disable max-len */
    shape: _react2.default.createElement('path', { d: 'M 11.5,3.705 10.33,2.5 5.084,7.897 4.5,8.5 5.085,9.103 10.33,14.5 11.501,13.295 6.842,8.5 Z', transform: 'rotate(-90,4.5005,7.0005)' }),
    /* eslint-enable max-len */
    viewbox: '0 0 12 7.0009999',
    label: 'Chevron down'
};
//# sourceMappingURL=chevron.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/cn-skin-core/lib/cjs/svg/chevron.js
 ** module id = 289
 ** module chunks = 0
 **/